import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useCheckpointAuthStore } from './stores/checkpointAuthStore';
import CheckpointPage from './pages/CheckpointPage';
import ReportsPage from './pages/ReportsPage';
import CheckpointSelector from './components/CheckpointSelector';
import ShortcodeLoginPage from './pages/ShortcodeLoginPage';
import ErrorBoundary from './components/ErrorBoundary';

/**
 * CheckpointApp (Shortcode Mode)
 * Gerencia a navegação e autenticação para o shortcode externo [haklai_checkpoint].
 */
// eslint-disable-next-line react/prop-types, no-unused-vars
function CheckpointApp({ apiUrl, pluginUrl }) {
  const { isAuthenticated } = useCheckpointAuthStore();

  // O store já rehidrata automaticamente do localStorage via zustand persist


  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          {/* Rota Protegida para Autenticação */}
          {!isAuthenticated ? (
            <Route path="*" element={<ShortcodeLoginPage onLoginSuccess={() => window.location.hash = '#/'} />} />
          ) : (
            <>
              {/* Listagem de Checkpoints (Relatórios) */}
              <Route path="/reports" element={<ReportsPage editPath="/" />} />

              {/* Seleção de Célula/Evento */}
              <Route path="/select" element={<CheckpointSelector />} />

              {/* Interface de Marcação de Presença */}
              <Route path="/" element={<CheckpointPage />} />

              {/* Redirecionamentos Genéricos */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          )}
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default CheckpointApp;
